// import React, { useEffect, useState } from "react";
// import { Modal, Button } from "antd";

// const WarningModal = ({
//   visible,
//   onClose,
//   messageContent,
//   onCreateValuation,
// }) => {
//   const [loading, setLoading] = useState(false);
//   const handleOkButton = async () => {
//     if (loading) return;
//     setLoading(true);
//     await onCreateValuation();
//     setLoading(false);
//     onClose();
//   };
//   return (
//     <Modal
//       className="warn-disclaimer"
//       open={visible}
//       // onCancel={onClose}
//       closable={false}
//       // title="Notice"
//       footer={[
//         // <Button key="back" onClick={onClose}>
//         //   Close
//         // </Button>,
//         <Button
//           key="create"
//           type="primary"
//           onClick={handleOkButton}
//           loading={loading}
//           disabled={loading}
//           className="warn-modal"
//         >
//           OK
//         </Button>,
//       ]}
//     >
//       <div className="container_disclaimer">
//         {messageContent.split("\n").map((line, index) => (
//           <div className={`disclaimer${index}`} key={index}>
//             {line}
//           </div>
//         ))}
//         {/* <div className="disclaimer-note">
//           Note: The unavailability of certain underlying actual data may lead to
//           a greater variance in the estimates of dealership valuation and
//           performance. Please input your own actual dealership values wherever
//           possible to improve accuracy.
//         </div> */}
//       </div>
//     </Modal>
//   );
// };

// export default WarningModal;
import React, { useState } from "react";
import { Modal, Button } from "antd";

const WarningModal = ({
  visible,
  onClose,
  messageContent,
  onCreateValuation,
}) => {
  const [loading, setLoading] = useState(false);
  
  const handleOkButton = async () => {
    if (loading) return;
    
    setLoading(true);
    try {
      // Check if onCreateValuation exists before calling
      if (onCreateValuation && typeof onCreateValuation === 'function') {
        await onCreateValuation();
      }
    } catch (error) {
      // Handle any errors that occur during onCreateValuation
      console.error('Error in onCreateValuation:', error);
    } finally {
      setLoading(false);
      // Call onClose if it exists
      if (onClose && typeof onClose === 'function') {
        onClose();
      }
    }
  };

  // Handle null, undefined, or non-string messageContent
  const safeMessageContent = messageContent || '';

  return (
    <Modal
      className="warn-disclaimer"
      open={visible}
      closable={false}
      footer={[
        <Button
          key="create"
          type="primary"
          onClick={handleOkButton}
          loading={loading}
          disabled={loading}
          className="warn-modal"
        >
          OK
        </Button>,
      ]}
    >
      <div className="container_disclaimer">
        {safeMessageContent.split("\n").map((line, index) => (
          <div className={`disclaimer${index}`} key={index}>
            {line}
          </div>
        ))}
      </div>
    </Modal>
  );
};

export default WarningModal;